// extracted by mini-css-extract-plugin
module.exports = {"info":"StatusBarInfoBox-StatusBarInfoBox-info--puqdxHn"};